import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const customerServiceProductsRoute: InvariantJiraRoute = {
	name: 'customer-service-products',
	path: '/jira/customer-service/products',
	exact: true,
};
